<template>
  <div>
    <v-text-field @click="openDialog()" v-bind="$attrs" :value="label" readonly>
      <template #append>
        <v-btn icon style="margin-top: -5px">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field>

    <Dialog
      ref="dialog"
      title="Escolha o cliente"
      :width="400"
      :height="400"
      scrollable
    >
      <v-card-subtitle>
        <v-text-field
          v-model="search"
          @change="loadClients()"
          class="mt-2"
          label="Pesquisar"
          prepend-inner-icon="mdi-magnify"
          solo
          autofocus
        >
          <template #append>
            <v-btn
              v-if="search !== ''"
              @click="search = ''"
              color="primary"
              icon
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-card-subtitle>

      <v-card-text style="margin-top: -40px">
        <v-radio-group v-model="selectedClient">
          <v-radio
            v-for="client in clients"
            :key="client.id"
            :label="client.nome"
            :value="client"
          >
          </v-radio>
        </v-radio-group>
        <div
          v-if="clients.length === 0 && loadedSearch === ''"
          class="text-center"
        >
          Digite para pesquisar um cliente
        </div>
        <div v-else-if="clients.length === 0" class="text-center">
          Nenhum cliente encontrado para "<b>{{ loadedSearch }}</b
          >"
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" text>
          Cancelar
        </v-btn>
        <v-btn
          @click="handleSelectClient()"
          color="primary"
          :disabled="selectedClient === null"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/dialogos/Dialogo.vue";
import { index } from "@/services/clients.js";

export default {
  mixins: [],

  components: {
    Dialog
  },

  props: {
    modelValue: Object
  },

  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },

  data() {
    return {
      loading: false,
      clients: [],
      search: "",
      loadedSearch: "",
      selectedClient: null
    };
  },

  methods: {
    openDialog() {
      this.$refs.dialog.open();
      this.search = "";
      this.clients = [];
      this.selectedClient = null;
    },

    closeDialog() {
      this.$refs.dialog.close();
    },

    async loadClients() {
      if (this.search === this.loadedSearch) {
        return;
      }
      this.clients = [];
      if (this.search === "") {
        this.loadedSearch = "";
        return;
      }

      const response = await index(
        {
          page: 1,
          itemsPerPage: 50,
          sortBy: ["nome"],
          sortDesc: false
        },
        this.search
      );

      this.clients = response.data;
      this.loadedSearch = this.search;
    },

    handleSelectClient() {
      if (this.selectedClient === null) {
        return;
      }

      this.$emit("update:modelValue", { ...this.selectedClient });
      this.closeDialog();
    }
  },

  watch: {
    search(value) {
      if (!value) {
        this.loadClients();
      }
    }
  },

  computed: {
    label() {
      if (this.modelValue) {
        return this.modelValue.nome;
      }

      return "";
    }
  }
};
</script>
